import React from 'react'
import { UIButton, type UIButtonProps } from './ui-button'
import { cn } from '../../lib/utils'

export interface UIButtonFullWidthProps extends UIButtonProps {
}

/**
 * Full Width Button Component
 * Based on common full-width button patterns
 * Use for modal actions, form submissions, card CTAs
 */
export const UIButtonFullWidth = React.forwardRef<HTMLButtonElement, UIButtonFullWidthProps>(
  ({ className, ...props }, ref) => {
    return (
      <UIButton
        className={cn("w-full", className)}
        ref={ref}
        {...props}
      />
    )
  }
)

UIButtonFullWidth.displayName = "UIButtonFullWidth"